export const quizQuestions = [
  {
    id: 1,
    question: "Quelle part de votre chiffre d'affaires provient du digital aujourd'hui ?",
    options: [
      "Moins de 10 %",
      "Entre 10 % et 30 %",
      "Entre 30 % et 60 %",
      "Plus de 60 %"
    ]
  },
  {
    id: 2,
    question: "Quel est votre plus grand défi en matière d'acquisition digitale ?",
    options: [
      "Générer suffisamment de leads qualifiés",
      "Convertir les visiteurs en clients",
      "Mieux mesurer mes performances",
      "Je ne sais pas vraiment par où commencer"
    ]
  },
  {
    id: 3,
    question: "Utilisez-vous l'intelligence artificielle (IA) dans votre processus commercial ?",
    options: [
      "Oui, activement",
      "J'ai commencé à tester",
      "J'envisage de le faire prochainement",
      "Pas du tout pour l'instant"
    ]
  },
  {
    id: 4,
    question: "Vos équipes marketing et commerciales sont-elles équipées d'outils digitaux ?",
    options: [
      "Oui, nous utilisons un CRM et de l'automation",
      "Oui, mais partiellement",
      "Nous utilisons encore peu d'outils",
      "Pas du tout"
    ]
  },
  {
    id: 5,
    question: "Mesurez-vous précisément le ROI de vos actions digitales ?",
    options: [
      "Oui, avec des outils de tracking performants",
      "Partiellement, via quelques KPIs",
      "Très peu, c'est flou",
      "Pas du tout"
    ]
  },
  {
    id: 6,
    question: "Quel canal digital vous apporte les meilleurs résultats aujourd'hui ?",
    options: [
      "SEO / contenu organique",
      "Publicité en ligne (Google Ads, Meta…)",
      "Emailing ou CRM",
      "Aucun canal ne se démarque vraiment"
    ]
  },
  {
    id: 7,
    question: "Quel budget annuel allouez-vous à votre stratégie digitale ? (en CHF)",
    options: [
      "Moins de 5 000 CHF",
      "Entre 5 000 et 20 000 CHF",
      "Entre 20 000 et 50 000 CHF",
      "Plus de 50 000 CHF"
    ]
  }
];

export const mockScores = {
  overall: 72,
  categories: [
    { name: "SEO", score: 68 },
    { name: "Technique", score: 85 },
    { name: "Conversion", score: 63 }
  ]
};

export const mockRecommendations = [
  {
    title: "Optimisation SEO locale",
    description: "Créez des pages de destination spécifiques pour chaque zone géographique ciblée et optimisez votre présence sur Google My Business."
  },
  {
    title: "Amélioration de la vitesse mobile",
    description: "Optimisez les images et mettez en place un système de mise en cache pour améliorer les performances sur mobile."
  },
  {
    title: "Stratégie de contenu",
    description: "Développez un calendrier éditorial régulier ciblant les mots-clés pertinents pour votre secteur."
  }
];